export const READONLY_FIELD_TYPES = {
  HEADER: 'HEADER',
  RICH_TEXT: 'RICH_TEXT',
  SUBMIT_BUTTON: 'SUBMIT_BUTTON',
  ECOM_CONTACT_DETAILS: 'ECOM_CONTACT_DETAILS',
  ECOM_SHIPPING_DETAILS: 'ECOM_SHIPPING_DETAILS',
  BOOKINGS_HEADER: 'BOOKINGS_HEADER'
};
//# sourceMappingURL=readonly-field-types.js.map